import React, { ReactElement } from 'react';
import DragIcon from '../../icons/drag-icon';
import useStylesDragHandle from './drag-handle.styles';

const DragHandle: ReactMemoComponent = React.memo((): ReactElement => {
  const { classes } = useStylesDragHandle();

  return <DragIcon className={classes.dragHandleIcon} />;
});

export default DragHandle;
